import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AlertMessageComponent, AlertModule as CosoAlertModule } from "@coso/alert";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { GridModule } from "@coso/grid";
import { DynamicViewModule, UtilityModule } from "@coso/utility";
import { AlertModule } from "ngx-bootstrap/alert";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { PageHeaderModule } from "../../page-header/page-header.module";
import { HistoryLogsComponent } from "./history-logs/history-logs.component";
import { LogsRoutingModule } from "./logs-routing.module";
import { LogsTableComponent } from "./logs-table/logs-table.component";

@NgModule({
  declarations: [HistoryLogsComponent, LogsTableComponent],
  imports: [
    CommonModule,
    LogsRoutingModule,
    PageHeaderModule,
    CosoAlertModule,
    AlertModule,
    FormsModule,
    TooltipModule,
    PaginationModule,
    DynamicViewModule,
    ButtonsModule,
    GridModule,
    CosoFormsModule,
    ReactiveFormsModule,
    UtilityModule,
    AlertMessageComponent
  ],
  exports: [LogsTableComponent]
})
export class LogsModule {}
